import React from 'react'
import { connectStateResults } from 'react-instantsearch/connectors'
import { Hits } from 'react-instantsearch/dom'
import styled from 'styled-components'
import SearchResultItem from './SearchResultItem'
import { Theme } from '@pga/pga-component-library'

const NoResults = styled.div`
  text-align: center;
  padding-top: 30px;
  font-family: ${Theme.fonts.Montserrat};
  font-size: 18px;
`

const SearchResultsWrapper = styled.div`
  .ais-Hits-list {
    display: block;
    margin: 0;
  }

  .ais-Hits-item {
    margin: 0;
    padding: 0;
    width: 100%;
    border: none;
    box-shadow: none;
  }
`

const CustomSearchHits = () => (
  <SearchResultsWrapper>
    <Hits hitComponent={SearchResultItem} />
  </SearchResultsWrapper>
)

export const SearchResults = ({ searchResults }) => {
  if (!searchResults) return null
  return searchResults && searchResults.nbHits !== 0
    ? <CustomSearchHits />
    : (
      <NoResults>
        <p>We're sorry. There are no results that match your search.</p>
      </NoResults>
    )
}

export default connectStateResults(SearchResults)
